import React from 'react';
import { Row, Col, Card, Statistic, Typography, Button, Divider } from 'antd';
import {
    HddOutlined, ShareAltOutlined,
    ArrowUpOutlined, ArrowDownOutlined, RightOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

// TODO: 联调时替换为接口数据
const MOCK_DEVICE = {
    dist_total: 2000, share_device: 350, active_total: 1560, online_total: 890,
    month_active: 128, yesterday_active: 15,
};
const MOCK_SHARE = {
    amount_total: 128500.00,
    yesterday_amount: 1280.00, yesterday_rate: 5.2,
    month_amount: 18600.00, month_rate: 8.3,
    order_total: 3200,
    month_order: 460, yesterday_order: 22,
};

const StatCard = ({ title, value, prefix, suffix, precision, sub, valueStyle }) => (
    <Card bordered style={{ borderRadius: 12 }} bodyStyle={{ padding: '16px 20px' }}>
        <Statistic title={title} value={value} prefix={prefix} suffix={suffix} precision={precision ?? 0}
            valueStyle={{ fontWeight: 600, fontSize: 24, ...valueStyle }} />
        {sub && <Text style={{ fontSize: 12, color: '#999', marginTop: 4, display: 'block' }}>{sub}</Text>}
    </Card>
);

const RateText = ({ value }) => {
    if (value == null) return null;
    const up = value >= 0;
    return <span style={{ color: up ? '#52c41a' : '#ff4d4f' }}>{up ? <ArrowUpOutlined /> : <ArrowDownOutlined />} {Math.abs(value)}%</span>;
};

const SectionHeader = ({ icon, title, link, onClick }) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <Title level={5} style={{ margin: 0 }}>{icon} {title}</Title>
        {link && <Button type="link" size="small" onClick={onClick}>{link} <RightOutlined /></Button>}
    </div>
);

const HomeSub = () => {
    const navigate = useNavigate();

    return (
        <div style={{ padding: 24, minHeight: '100%' }}>
            {/* <div style={{ marginBottom: 16 }}><Title level={4}>首页看板</Title></div> */}

            {/* 设备概览 */}
            <SectionHeader icon={<HddOutlined />} title="设备概览" link="查看详情" onClick={() => navigate('/distribution/proxy')} />
            <Row gutter={[16, 16]} style={{ marginBottom: 32 }}>
                <Col span={5}><StatCard title="分销设备总量" value={MOCK_DEVICE.dist_total} valueStyle={{ color: '#1890ff' }} sub="上级分销" /></Col>
                <Col span={5}><StatCard title="分润设备数" value={MOCK_DEVICE.share_device} valueStyle={{ color: '#722ed1' }} sub="参与分润的设备" /></Col>
                <Col span={5}><StatCard title="激活设备总量" value={MOCK_DEVICE.active_total} valueStyle={{ color: '#52c41a' }} sub={`激活率 ${(MOCK_DEVICE.active_total / MOCK_DEVICE.dist_total * 100).toFixed(1)}%`} /></Col>
                <Col span={5}><StatCard title="在线设备总量" value={MOCK_DEVICE.online_total} valueStyle={{ color: '#52c41a' }} sub={`在线率 ${(MOCK_DEVICE.online_total / MOCK_DEVICE.active_total * 100).toFixed(1)}%`} /></Col>
                <Col span={4}><StatCard title="当月新增激活" value={MOCK_DEVICE.month_active} valueStyle={{ color: '#fa8c16' }} sub={`昨日 +${MOCK_DEVICE.yesterday_active}`} /></Col>
            </Row>

            <Divider />

            {/* 分润概览 */}
            <SectionHeader icon={<ShareAltOutlined />} title="分润概览" link="查看详情" onClick={() => navigate('/share/profit/income')} />
            <Row gutter={[16, 16]}>
                <Col span={5}><StatCard title="分润总收入" value={MOCK_SHARE.amount_total} prefix="¥" precision={2} valueStyle={{ color: '#1890ff' }} sub="累计" /></Col>
                <Col span={5}><StatCard title="昨日分润" value={MOCK_SHARE.yesterday_amount} prefix="¥" precision={2} valueStyle={{ color: '#52c41a' }}
                    sub={<>较前日 <RateText value={MOCK_SHARE.yesterday_rate} /></>} /></Col>
                <Col span={5}><StatCard title="当月分润" value={MOCK_SHARE.month_amount} prefix="¥" precision={2} valueStyle={{ color: '#52c41a' }}
                    sub={<>较上月 <RateText value={MOCK_SHARE.month_rate} /></>} /></Col>
                <Col span={5}><StatCard title="分润订单总量" value={MOCK_SHARE.order_total} valueStyle={{ color: '#1890ff' }} sub="累计" /></Col>
                <Col span={4}><StatCard title="当月分润订单" value={MOCK_SHARE.month_order} valueStyle={{ color: '#fa8c16' }} sub={`昨日 +${MOCK_SHARE.yesterday_order}`} /></Col>
            </Row>
        </div>
    );
};

export default HomeSub;
